import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, cursor: 'pointer' }} onClick={() => navigate('/')}>
          MENTENG RENT
        </Typography>
        <Box>
          <Button color="inherit" onClick={() => navigate('/')}>Home</Button>          
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;